<script>
import { ErrorWrapper } from '@utils/error-handler'
import { BOverlay } from 'bootstrap-vue'
import { authComputed, collegeListMethod } from '@state/helpers'

export default {
  components: {
    'b-overlay': BOverlay,
  },
  props: {
    data: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      name: '',
      collegeCode: '',
      collegeError: null,
      isCollegeError: false,
      isLoading: false,
      show: false,
      platformId: 0,
      collegeSuccess: '',
      isCollegeSuccess: false,
    }
  },
  computed: {
    ...authComputed,
  },
  mounted() {},
  methods: {
    ...collegeListMethod,
    updateCollege() {
      this.isLoading = true
      const Data = {
        id: this.data._id,
        name: this.name,
        collegeCode: this.collegeCode,
      }
      this.updateCollegeData({ Data })
        .then((resp) => {
          this.isLoading = false
          this.collegeSuccess = 'College Updated Successfully'
          this.isSuccess = true
          window.location.reload()
        })
        .catch((error) => {
          this.isLoading = false
          var getError = new ErrorWrapper(error)
          this.collegeError = getError.message
          this.isCollegeError = true
        })
    },

    getData() {
      this.name = this.data.name
      this.collegeCode = this.data.collegeCode
    },

    resetModal() {
      this.isCollegeError = false
    },

    restrictChars(event) {
      if (event.charCode === 32 && !this.name.length) {
        event.preventDefault()
      } else {
        return true
      }
    },
  },
}
</script>

<template>
  <b-modal
    id="college-update-modal"
    title="Update"
    :hide-footer="true"
    @shown="getData"
    @hidden="resetModal"
  >
    <b-overlay :show="show" :opacity="0.6" rounded="sm">
      <b-card>
        <b-alert
          v-model="isCollegeError"
          variant="danger"
          v-html="collegeError"
        ></b-alert>
        <b-alert
          v-model="isCollegeSuccess"
          variant="success"
          v-html="collegeSuccess"
        ></b-alert>
        <b-form @submit.prevent="updateCollege">
          <b-form-group label="College Name" label-for="input-1">
            <b-form-input
              id="input-1"
              v-model="name"
              type="text"
              placeholder="Enter College Name"
              @keypress="restrictChars($event)"
            ></b-form-input>
          </b-form-group>

          <b-form-group label="College Code" label-for="input-1">
            <b-form-input
              id="input-1"
              v-model="collegeCode"
              type="text"
              placeholder="Enter College Code"
              @keypress="restrictChars($event)"
            ></b-form-input>
          </b-form-group>
          <b-form-group id="button-group" class="mt-4">
            <b-button v-if="!isLoading" type="submit" variant="primary"
              >Save</b-button
            >
            <b-button
              v-else
              type="submit"
              variant="primary"
              class="btn-block"
              disabled
            >
              <b-spinner small></b-spinner>Loading...
            </b-button>
          </b-form-group>
        </b-form>
      </b-card>
    </b-overlay>
  </b-modal>
</template>
<style>
.btn .b-icon.bi,
.dropdown-item .b-icon.bi,
.dropdown-toggle .b-icon.bi,
.input-group-text .b-icon.bi,
.nav-link .b-icon.bi {
  color: gray !important;
}

.btn-secondary {
  color: #fff !important;
  background-color: white !important;
  border-color: #ced4da !important;
}

.note {
  font-size: 16px;
  color: black;
  background-color: yellow;
}
</style>
